/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Source_KiaiInputs */



/**
* | output |
* | --- |
* | "Kiai" |
*
* @param {Leveling_Source_KiaiInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_source_kiai = /** @type {((inputs?: Leveling_Source_KiaiInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Source_KiaiInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Kiai")
	return /** @type {LocalizedString} */ ("Kiai")
});